class HappyFoxChatService {
    openChatBox = () => window.HappyFoxChat && window.HappyFoxChat.expandChatbox()
}

export default HappyFoxChatService